let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j6UWm")).then(() => parcelRequire('i4rav'));